import withLayout from "components/widgets/layout";
import { Portlet } from "@customcomponents";
import MasterDocs from "@widgets/MasterDocs";

const MasterDocsPage = () => {
  return (
    <Portlet>
      <Portlet.Body>
        <MasterDocs />
      </Portlet.Body>
    </Portlet>
  );
};

MasterDocsPage.pageTitle = "P+ Media Plan";
MasterDocsPage.headerTitle = "Master Documents";

export default withLayout(MasterDocsPage);
